/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const Tulu3405B = ({ color = 'primary', aspectRatio = '1173/137', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="Tulu3-405B" aspectRatio={aspectRatio} color={color} {...rest} />;

export { Tulu3405B, Tulu3405B as default };
